import * as React from 'react';
import { useDispatch } from 'react-redux';

import {
  getOffersHistory,
  openOfferFromHistory,
  setCategoriesFilter,
  setPage,
} from '../../../../actions/offersHistory';
import { FILTER_ALL_VALUE, TCategoriesFilterOptionValue } from '../../../../store/offerHistory';
import { trackFiltersChange } from '../analytics';

export const useHandleCategoriesFiltersClick = () => {
  const dispatch = useDispatch();

  return React.useCallback(
    async (_: React.ChangeEvent, value: string) => {
      const _value = value as TCategoriesFilterOptionValue;

      dispatch(setCategoriesFilter(_value === FILTER_ALL_VALUE ? FILTER_ALL_VALUE : _value));

      dispatch(setPage(1));
      await dispatch(getOffersHistory(false));
      dispatch(trackFiltersChange());
      await dispatch(openOfferFromHistory());
    },
    [dispatch],
  );
};
